<script>
import DropDown from "../../../../assets/js/vue/icons/drop-down.vue";

export default {
    name: "SelectInput",
    components: {DropDown},
    props: {
        placeholder: {
          type: String,
          default: 'Select an option',
        },
        options: {},
        value: {
            type: [Number],
            default: null,
        },
        disabled: Boolean,
        buttonClass: String
    },
    data() {
        return {
            selectedIndex: this.value,
            open: false,
        }
    },
    watch: {
      value(newValue, oldValue) {
          if ( newValue !== oldValue ) {
              this.selectedIndex = newValue;
          }
      }  
    },
    methods: {
        selectOption(index) {
            this.selectedIndex = index;
            this.open = false;
            this.$emit("change", this.selectedIndex);
        }, 
        openSelect() {
            if ( this.open ) {
                this.closeSelect();
            }
            else {
                this.updateContentPosition();
                window.addEventListener("resize", this.updateContentPosition);
                document.addEventListener("click", this.closeSelectOutside);
                this.open = true;
            }
        },
        closeSelect() {
            window.removeEventListener("resize", this.updateContentPosition);
            document.removeEventListener("click", this.closeSelectOutside);
            this.open = false;
        },
        getCurrentOption() {
          return this.options[this.selectedIndex];  
        },
        getLabel(index = this.selectedIndex) {
            if ( index === null ) return '';
            const option = this.options[index];
            const price = typeof option.getPricePerType === 'function' && typeof option.getTypeLabel === 'function' && Number(option.getPricePerType()) > 0 ? `- £${option.getPricePerType()} ${option.getTypeLabel()}` : '';
            return option.label + " " + price;
        },
        closeSelectOutside(e) {
            if ( !this.$refs['selectWrapper'].contains(e.target) )
                this.closeSelect()
            
        },
        updateContentPosition() {
            const wrapper = this.$refs['selectWrapper'];
            const content = this.$refs['selectContent'];
            
            content.style.left = `${wrapper.getBoundingClientRect().left}px`;
            content.style.top = `${(wrapper.getBoundingClientRect().top + window.scrollY) + wrapper.clientHeight}px`;
            content.style.width = `${wrapper.clientWidth}px`;
        }
    },
}
</script>

<template>
    <div ref="selectWrapper" class="relative desktop-input desktop-input--select w-full"
         :class="{'active' : open, 'selected': selectedIndex !== null}">
        <button @click="openSelect" class="desktop-input__button" :disabled="disabled" :class="buttonClass">
            <span>{{  selectedIndex === null ? placeholder : getLabel() }}</span>
            <drop-down/>
        </button>
        
        <MountingPortal append mountTo="#configurator-field-menu" multiple>
            <div ref="selectContent" class="desktop-input__content" :class="{'open': open}">
                <button
                    v-for="(field, index) in options"
                    :class="{ 'selected' :  index === selectedIndex}"
                    @click="selectOption(index)"
                >{{ getLabel(index) }} 
                </button>
            </div>
        </MountingPortal>
    </div>
</template>

<style scoped lang="scss">

</style>